/* src/app/modules_v2/booking/components/appointment-form/appointment-form.component.css */
/*# sourceMappingURL=appointment-form.component.css.map */
